"use strict";

var _Object$assign = require("babel-runtime/core-js/object/assign")["default"];

exports["default"] = _Object$assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.__esModule = true;


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/babel-runtime/helpers/extends.js
 ** module id = 290
 ** module chunks = 1
 **/